import React from "react";
import { Typography } from "@material-ui/core";
import { DPEmptyTable, DPTable } from "Components/DP";
import { Header } from "Components/DP/DPTable/DPTable";
import { EmployeeAnomalyRow } from "./EmployeeAnomalyRow/EmployeeAnomalyRow";
import { MeanHeadCell } from "./MeanHeadCell/MeanHeadCell";
import { DeviationHeadCell } from "./DeviationHeadCell/DeviationHeadCell";
import { usePayrollAnomalyOutliers } from "./usePayrollAnomalyOutliers";
import useStyles from "./styles";

const anomaliesHeaders: Header[] = [
  "Employee Name",
  "User ID",
  "Net Pay",
  <MeanHeadCell />,
  <DeviationHeadCell />
];

export interface EmployeeAnomaliesTableProps {
  netEarningsFileId: string;
}

export const EmployeeAnomaliesTable = ({ netEarningsFileId }: EmployeeAnomaliesTableProps) => {
  const classes = useStyles();
  const {
    payrollAnomalyOutliers,
    page,
    rowsPerPage,
    handlePageChange,
  } = usePayrollAnomalyOutliers(netEarningsFileId);

  return (
    <>
      <Typography
        variant="h3"
        className={classes.title}
      >
        Employee Anomalies
      </Typography>
      <DPTable
        id="dailypay-employee-anomalies"
        headers={anomaliesHeaders}
        count={payrollAnomalyOutliers?.totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        colWidths={[25, 20, 20, 20]}
        className={classes.table}
        onChangePage={handlePageChange}
      >
        {payrollAnomalyOutliers?.totalCount
          ? payrollAnomalyOutliers?.items.map(
            (anomaly, idx) => <EmployeeAnomalyRow key={idx} anomaly={anomaly} />
          )
          : <DPEmptyTable message="Anomalies will be dispayed here." />
        }
      </DPTable>
    </>
  );
};
